// extracted by mini-css-extract-plugin
export var navbarSubLink = "G_f6 d_f6 d_f0 d_X d_b8 d_dj d_bp d_bQ";
export var menuLink = "G_tD d_fX d_dx";
export var subPageLink = "G_gb d_gb d_dn d_dr";
export var subPageLinkColor = "G_gc d_gc";
export var burgerItemSmall = "G_tF d_f9 d_W d_bq";
export var Link = "G_sz x_sz x_rV x_sd";